<template>
    <v-card rounded="lg" flat color="grey-f7" style="overflow: unset;">
        <div class="pa-20 pa-md-30 pa-lg-40">
            <v-row class="row--x-small">
                <v-col cols="12" lg="6" class="mb-6 mb-lg-0">
                    <v-row class="row--x-small">
                        <v-col cols="12" md="auto" class="mb-10 mb-md-0">
                            <p class="page-text font-weight-medium min-w-lg-100px mt-md-10 mt-lg-12">근로 계약 기간</p>
                        </v-col>
                        <v-col>
                            <v-row align="center" class="row--x-small">
                                <v-col cols="12" xl="auto">  
                                    <v-row align="center" class="row--x-small">
                                        <v-col>
                                            <v-date-field v-model="filter.startsAt" v-bind="attrs_input" class="mw-lg-170px" :disabled="filter.fixedCheck"/>
                                        </v-col>
                                        <v-col cols="auto">
                                            <p class="page-text page-text--sm">~</p>
                                        </v-col>
                                        <v-col cols="12" sm="">
                                            <v-date-field v-model="filter.endsAt" v-bind="attrs_input" class="mw-lg-170px" :disabled="filter.fixedCheck"/>
                                        </v-col>
                                    </v-row>                                    
                                </v-col>
                                <v-col cols="12" xl="auto">
                                    <v-checkbox v-model="filter.fixedCheck" hide-details label="근로 기간의 정함이 없음" class="v-input--checkbox--lg"/>               
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" lg="6">
                    <v-row class="row--x-small">
                        <v-col cols="12" lg="">
                            <v-select
                                v-bind="attrs_input"
                                v-model="filter.searchKey"
                                placeholder="성명,아이디,전화번호,이메일,근무처,계약서" 
                                :items='searchKeys'
                                item-text="text"
                                item-value="value"
                                />
                        </v-col>
                        <v-col>
                            <v-text-field v-model="filter.searchValue" v-bind="attrs_input" placeholder="검색내용을 입력하세요." class="v-text-field--search">
                                <template #prepend-inner>
                                    <v-btn icon text><i class="icon icon-search-black"></i></v-btn>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="auto">
                            <v-btn color="grey-6" block dark class="min-w-sm-80px min-w-lg-100px" @click="()=>{$router.push({ query: filter })}">검색</v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>
    </v-card>
</template>

<script>
import VDateField from "@/components/plugins/vuetify/v-date-field.vue";
import { attrs_input, } from "@/assets/variables";
export default {
    components: {
        VDateField,
    },
    data: () => ({
        attrs_input,
        filter: {
            searchKey: null,
            searchValue: null,
            startsAt: null,
            endsAt: null,
            fixedCheck: false
        },
        searchKeys:[
            { value:"name", text: '성명' },
            { value:"id", text: '아이디' },
            { value:"phone", text: '전화번호' },
            { value:"email", text: '이메일' },
            { value:"place", text: '근무처' },
            { value:"form", text: '계약서' },
        ],
    }),
    watch:{
        "filter.fixedCheck"(){
            this.filter.startsAt = null;
            this.filter.endsAt = null;
        }
    }
}
</script>

<style lang="scss" scoped>
.row--x-small{
    margin: -4px;
}
.row--x-small>[class*=col] {
    padding: 4px;
}
</style>